var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('a',{staticClass:"list-page__action-item w-inline-block",class:{
                  star: !_vm.isStarred,
                  starred: _vm.isStarred,
                },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleStarState($event)},"mouseleave":_vm.onMouseLeaveHandler}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }